// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"cd60fda6","510":"ae37b187","832":"bba053cd","900":"6fbc360e"}[chunkId] + ".chunk.js";
};